module.exports = __webpack_public_path__ + "img/vox.153e7809.png";